export default __webpack_public_path__ + "static/media/profile-img.993a2481.png";